<template>
<div>
<div class="height-set-for-component" ref="fadeWhenModelOpen">
  <div class="d-flex">
      <div class="search-bar-comm-style pt-2 col-md-6">
        <input
            type="text"
            class="rounded text-light search-bar"
            placeholder="Search field"
            autocomplete="off" v-model="searchFilters.name" @input="updateCustomMetadataLstFromServer(false)"/>
        <Multiselect
            :value="searchFilters"
            :options="fieldTypes"
            :searchable="true"
            :close-on-select="true"
            :allow-empty="false"
            @select="filterByType($event)"
            label="label"
            deselectLabel=""
            selectLabel=""
            selectedLabel=""
            :placeholder="$t('Select Field Type') "
            track-by="type">
            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
            <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
            </div>
            <span slot="noResult">No results.</span>
          </Multiselect>
      </div>
      <div class="primary-btn-style justify-content-end mr-3 pt-2 col-md-6">
        <button class="learn-about-text-styles" @click="openLearnAboutPanel()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lightbulb-fill" viewBox="0 0 16 16">
            <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"/>
          </svg>{{$t('Learn about fields')}}
        </button>
        <!-- <button class="btn btn-outline-danger mr-2" style="border: 1px solid #831515;" v-on:click="deleteCustMetadata()">Delete</button> -->
        <!-- <button class="btn btn-outline-secondary m-2"  style="border: 1px solid #585858;" v-on:click="editCustomMetadata('custom-metadata-info')">Edit</button> -->
        <button class="btn btn-outline-primary m-2" v-on:click="changeToSelectedCustomMetadataTableComponent('add-custom-metadata')">{{$t('Add')}}</button>
      </div>
    </div>
  <div class="pl-4 h-100 pt-0 pr-4 pb-2" style="overflow:auto">
    <table class="table-with-border table-scroll small-first-col" style="background: transparent">
      <thead style="color: #eee">
        <tr>
          <th style="width: 35%">{{$t('Name')}}</th>
          <th style="width: 12%">{{$t('Type')}}</th>
          <th style="width: 18%">{{ $t('Parent Field') }}</th>
          <th style="width: 20%" class="text-center">{{$t('Date Created')}}</th>
          <th style="width: 15%"></th>
        </tr>
      </thead>
      <tbody class="body-half-screen">
        <tr v-for="key in customMetadataList" :key="key._id" :id="key._id"         
        @click="selectRow(key), changeToSelectedCustomKeyComponent('custom-metadata-info', key)"
            :class="{activeclass: actveCustMetadata == key._id}"
            class="comm-user-row show-delete-icon">
             <!-- @dblclick="changeToSelectedCustomKeyComponent('custom-metadata-info', key)"  -->
          <td class="text-left" style="text-transform: capitalize;">
            {{getCustomMetadataName(key)}}
          </td>
          <td style="text-transform: capitalize;">
            <span v-show="key.type == 'FREETEXT'">Plaintext</span>
            <span v-show="key.type != 'FREETEXT'">{{getFieldType(key.type).toLowerCase()}}</span>
          </td>
          <td>
            {{ ('load_when' in key && key.load_when[0] && Object.keys(key.load_when[0].length>0) && key.load_when[0].name )? key.load_when[0].name : 'Root' }}
          </td>
          <td class="text-center" :title="getDateAndTimeInConfiguredFormat(key.created_datetime)">
            {{ getDateAndTimeInConfiguredFormat(key.created_datetime, true) }}
          </td>
          <td style="position: relative;padding:0px !important">
            <!-- <div class="dropdown" style="float:inline-start">
              <div class="nav-item nav-link dropdown-toggle mr-md-2" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                <svg width="15" height="1.5em" viewBox="0 0 16 16" class="bi bi-three-dots more-actions-btn"  fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
                </svg>
              </div>
              <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions">
                <a class="dropdown-item p-2" @click.stop.prevent="deleteCustomMetadata(key._id, key.name)">
                  <svg width="15" height="15" viewBox="0 0 16 16" class="bi bi-trash-fill" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7z"/>
                  </svg>
                  Delete
                </a>
              </div>
            </div> -->
            <svg  @click.stop.prevent="changeToSelectedCustomKeyComponent('custom-metadata-info', key)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-pencil parent-row-edit" viewBox="0 0 16 16">
              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
            </svg>
            <svg @click.stop.prevent="deleteCustomMetadata(key)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-trash parent-row-delete" viewBox="0 0 16 16">
                <title>Delete</title>
                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
            </svg>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
   <div>
    <pagination
        v-model="page"
        :records="totalTags"
        :per-page="perPage"
        @paginate="paginate"
        :options="options"
    />
    </div>
</div>
<CustomMessage v-if="enableCustomMessage" v-bind="currentProperties" :jobStatusInfo="bulkFieldUpdateJobInfo" @close="acceptMessage()" @allowUpdation="handleConfirmResp()" @allowDeletion="handleConfirmResp()"></CustomMessage>
<component :is="selectedComponenet" @close="closeLearnAboutPanel"></component>
</div>
</template>

<script>
import { mapActions,mapMutations } from "vuex";
import Utils from "../../components.utils.js"
import Pagination from "vue-pagination-2";
import Multiselect from 'vue-multiselect';
import LearnAbout from "./LearnAboutFields.vue";
import {NotifierConstants} from "../../components.constants.js";
import CustomMessage from "../actions/customAlertMessage.vue";
  
export default {
  props:["selectedCustomMetadataId","page","searchFilters"],
  components:{
    pagination: Pagination,
    "Multiselect":Multiselect,
    "learn-about":LearnAbout,
    CustomMessage
  },
  data(){
    return {
      totalPages: -1,
      totalTags: -1,
      perPage: -1,
      selectedRowDetails:{},
      actveCustMetadata:null,
      customMetadataList: [],
      options:{chunk:5},
      openlearnAboutPanel:false,
      selectedComponenet:null,
      fieldTypes:[
      {label:"All",type:"all"},
      {label:"Plaintext",type:"FREETEXT"},
      {label:"Freetext Multiline",type:"FREETEXT_MULTILINE"},
      {label:"Date",type:"DATE"},
      {label:"Date Time",type:"DATE_TIME"},
      {label:"Integer",type:"INTEGER"},
      {label:"Picklist",type:"PICKLIST"},
      {label:"Picklist Multivalue",type:"PICKLIST_MULTIVALUE"}
      ],
      enableCustomMessage:false,
      message:"",
      selectedFieldIdToDelete:null,
      bulkFeildUnset:false,
      bulkFieldUpdateJobInfo:null,
      deleteActionText:null,
      getUsersConfirmation:true
    };
  },
  computed:{
    currentProperties() {
          return {
                deleteButtonText:this.deleteActionText,
                messageType: "",
                messageTitle:"Confirm Deletion",
                displayMessage:this.message,
                getUserConfirmation:this.getUsersConfirmation,
                borderColor:"#007bff !important",
                backgroundColor:"#007bff !important"}
      }
  },
  methods: {
    getCustomMetadataName(fieldInfo){
      if('language_alias_mapper' in fieldInfo && fieldInfo.language_alias_mapper && fieldInfo.language_alias_mapper.length > 0 && this.$i18n && this.$i18n.locale){
        let mapperExists = fieldInfo.language_alias_mapper.find(op=>op.code == this.$i18n.locale)
        if(mapperExists && Object.keys(mapperExists).length > 0 && mapperExists.field_alias && mapperExists.field_alias.length > 0){
          return mapperExists.field_alias;
        }
      }
      return fieldInfo.name;
    },
    openLearnAboutPanel(){
      this.selectedComponenet = 'learn-about';
      this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
      this.$refs.fadeWhenModelOpen.style.pointerEvents = "none";
    },
    closeLearnAboutPanel(){
      this.selectedComponenet = null;
      this.$refs.fadeWhenModelOpen.style.opacity = 1;
      this.$refs.fadeWhenModelOpen.style.pointerEvents = "auto";
    },
    paginate(pageNo) {
      this.$emit("pageSwitched", pageNo);
      this.page = pageNo;
      this.updateCustomMetadataLstFromServer(true);
    },
    changeToSelectedCustomMetadataTableComponent(compName, payload = {}){
            this.$emit("changeToSelectedCustomMetadataTableComponent", compName, payload)
        },
    editCustomMetadata(comp){
      if(this.selectedRowDetails._id != undefined){
        this.changeToSelectedCustomMetadataTableComponent(comp,this.selectedRowDetails)
      }else{
        alert("Select Field to edit");
        return false;
      }
    },
    deleteCustMetadata(){
      if(this.actveCustMetadata != undefined){
        this.deleteCustomMetadata(this.selectedRowDetails._id,this.selectedRowDetails.name)
      }else{
        alert("Select Field to delete");
        return false;
      }
    },
    selectRow(key){
      this.selectedRowDetails = key;
      this.actveCustMetadata = key._id;
    },
    deleteCustomMetadata(fieldInfo){
      let keyName = this.getCustomMetadataName(fieldInfo);
      if(typeof keyName == "undefined" || keyName.trim().length <= 0){
        alert(this.$t("Select Field to delete"));
        return;
      }
      this.selectedFieldIdToDelete = fieldInfo._id;
      this.isCustomMetadataAttachedToAnyAsset({params:{_id:this.selectedFieldIdToDelete}}).then((data)=>{
        if(Utils.isAcceptedStatusCode(data.statusCode) && data.asset_tagged){
          this.message = this.$t(`Selected field "${keyName}" is in use.\nDo you want to unset and proceed for delete.`);
          this.deleteActionText = this.$t('Unset and Delete');
          this.enableCustomMessage = true;
          this.bulkFeildUnset = true;
          // this.selectedRowDetails = {};
          return
        }
        this.message = this.$t(`Are You sure you want to delete the selected "${keyName}" field? `);
        this.deleteActionText = this.$t('Delete');
        this.enableCustomMessage = true;
      })
      
    },
  
    handleConfirmResp(){
      if(this.selectedFieldIdToDelete && !this.bulkFeildUnset){
        this.enableCustomMessage = false
        this.deleteField();
      }else if(this.bulkFeildUnset){
        let payload={
          field_id:this.selectedFieldIdToDelete,
          job_name:"Bulk Field Unset",
          element_type:"assets"
        }
        this.createNewJob(payload).then((data)=>{
          if(Utils.isAcceptedStatusCode(data.statusCode)){
            this.$toast.success(this.$t("Job submitted successfully"));
            this.bulkFieldUpdateJobInfo={"job_id":data.job_id,"status_info":{"progress":0}, "state":"QUEUED"}
          }else{
            if('message' in data){
              this.$toast.error(data.message)
            }else{
              this.$toast.error("Failed to submit the job.")
            }
          }
        })
      }
    },
    acceptMessage(){
      this.selectedFieldIdToDelete=null;
      this.bulkFeildUnset=false;
      this.bulkFieldUpdateJobInfo=null;
      this.enableCustomMessage=false;
      this.deleteActionText = null;
      this.getUsersConfirmation=true;
    },
    deleteField(){
      this.deleteExistingCustomMetadata({params:{_id:this.selectedFieldIdToDelete}}).then((data)=>{
        if (Utils.isAcceptedStatusCode(data.statusCode)){
          this.$toast.success(data.message);
          this.customMetadataList = this.customMetadataList.filter(t=>t._id != this.selectedFieldIdToDelete);
        } else{
          this.$toast.error(data.message);
        }
      });
      this.selectedRowDetails = {};
    },
    changeToSelectedCustomKeyComponent(compName, metadataKeyInfo){
      this.$emit("changeToSelectedCustomKeyComponent", compName, metadataKeyInfo)
    },
    filterByType(fieldType){
      this.searchFilters = fieldType;
      this.updateCustomMetadataLstFromServer(false)
    },
    updateCustomMetadataLstFromServer(isPageClick = false){
      let payload = {}
      let filterBy = {}
      this.$emit("searchFiltersUpdated", this.searchFilters);
      if(isPageClick){
        filterBy['page'] = this.page
      }
      if(this.searchFilters.type != 'all'){
        filterBy.type = this.searchFilters.type
      }
      if(typeof(this.searchFilters.name) != 'undefined' &&
      this.searchFilters.name.trim().length > 0){
        filterBy.name = this.searchFilters.name
      }
      payload.params = filterBy
      this.getAllCustomMetadataFromServer(payload).then((data)=>{
        this.totalPages = data["page_count"];
        this.totalTags = data["total_custom_metadatas"];
        this.perPage = data["custom_metadatas_per_page"];
        this.customMetadataList = data.custom_metadatas
        this.selectedRowDetails = {}
      });
    },
    formatedDate(date){
      return Utils.getDateTimeFormat(date);
    },
    getFieldType(keyType){
      let a = keyType;
      a = a.replace("_", " ");
      return a;
    },
    addFieldtoList(entry_info){
      let entry_exists = this.customMetadataList.filter((f)=>f._id==entry_info._id)
      if (entry_exists.length ==0){
        this.customMetadataList.push(entry_info)
      }else{
        Object.assign(entry_exists[0], entry_info)
      }
    },
    handleNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let entry_info = notification.message
        if ([NotifierConstants.fieldRemovedNotification,
             NotifierConstants.fieldModifiedNotification].includes(notification.message_type)){
          let fieldId = null
          if('custom_metadata_id' in  entry_info){
            fieldId = entry_info.custom_metadata_id
          }else if('_id' in entry_info){
            fieldId = entry_info._id
          }
          if(!fieldId){
            return
          }
          let fIndex = this.customMetadataList.findIndex(item=>item._id == fieldId);
          if(fIndex >= 0){
            setTimeout(()=>{
              this.updateCustomMetadataLstFromServer(true);
            }, 100)
          }
        }else if(notification.message_type == NotifierConstants.fieldCreatedNotification){
          if(this.page == 1){
            setTimeout(()=>{
              this.updateCustomMetadataLstFromServer(true);
            }, 100)
          }
        }
      }
    },
    handleBulkMetadataUnsetNotification(notification){
      if(!this.bulkFieldUpdateJobInfo){
        return
      }

      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
              //handle progress notification
              let mssgInfo = notification.message;
              if(this.bulkFieldUpdateJobInfo && mssgInfo.job_id == this.bulkFieldUpdateJobInfo.job_id){
                let statusDetails = mssgInfo.status_info;
                if(typeof statusDetails != "undefined" &&
                  Object.keys(statusDetails).includes("progress")){
                    this.bulkFieldUpdateJobInfo = mssgInfo;
                    if(statusDetails["progress"] == 100){
                      this.getUsersConfirmation = false;
                      this.bulkFieldUpdateJobInfo = null;
                      let fieldInfo = this.customMetadataList.find(op=>op._id == this.selectedFieldIdToDelete) ;
                      this.message = this.$t(`Deleted the selected "${this.getCustomMetadataName(fieldInfo)}" field.`)
                    }
                }
              }
            }

    },
    ...mapActions("jobs", ["createNewJob"]),
    ...mapActions("customMetadata", ["getAllCustomMetadataFromServer", "isCustomMetadataAttachedToAnyAsset", "deleteExistingCustomMetadata"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
  },
  created() {
    this.addWSEventListener({
            eventname:[NotifierConstants.fieldCreatedNotification,
            NotifierConstants.fieldModifiedNotification,
            NotifierConstants.fieldRemovedNotification],
            callback:this.handleNotification,
            parent:"ShowCustomMetadatas"})
    this.addWSEventListener({
        eventname:["JOB_STATUS_UPDATE"],
        callback:this.handleBulkMetadataUnsetNotification,
        parent: "ShowCustomMetadatas"})
    this.updateCustomMetadataLstFromServer(true);
  },
  beforeDestroy(){
        this.removeWSEventListener({
            eventname:[NotifierConstants.fieldCreatedNotification,
            NotifierConstants.fieldModifiedNotification,
            NotifierConstants.fieldRemovedNotification],
            callback:this.handleNotification,
            parent:"ShowCustomMetadatas"})
        this.removeWSEventListener({
            eventname:["JOB_STATUS_UPDATE"],
            callback:this.handleBulkMetadataUnsetNotification,
            parent: "ShowCustomMetadatas"})
  }
};
</script>


<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;



.activeclass {
  color: $active-blue;
}

.key-div{
  color:$dull-text-color;
}

.search-bar-comm-style {
  margin-top: 5px;
  display:inline-flex;
  .search-bar{
    background: $primary-background !important;
    height:40px;
    width: 250px !important;
    float: inline-start;
    padding-inline-start: 12px;
    // margin: 0px 3% 0px 0px;
    margin: 0;
    margin-inline-end: 3%;  
    padding-bottom:2px;
    border: $border-color !important;
  }
}

// .table-scroll {
//   /*width:100%; */
//   height: 100%;
//   display: block;
//   empty-cells: show;
//   border: none!important;
//   /* Decoration */
//   border-spacing: 0;
//   border: 1px solid;
//   thead {
//     color: $dull-text-color !important;
//     position: relative;
//     display: block;
//     width: 100%;
//   }
//   tbody {
//     height:100%;
//     display: block;
//     position: relative;
//     width: 100%;
//     font-weight: 500;
//     overflow: auto;
//     max-height: calc(100vh - 150px);
//   }
// }


.table-scroll {
  /*width:100%; */
  border: none !important;
  /* Decoration */
  border-spacing: 0;
  width: 100%;
  thead {
    color: $dull-text-color !important;
    position: relative;
    th{
      position: sticky;
      top: 0;
      z-index:9;
      text-align: start;
      background: $primary-background;
      padding:5px;
    }
  }
  tbody {
    width: 100%;
    overflow: auto;
    font-weight: 500;
    tr{
      height:40px;
      td{
        text-align: start;
        padding: 5px;
      }
    }
  }
}

.table{
  th{
    border-top:none !important;
  }
  td{
    border-top:none !important;
  }
}


// .table-scroll tr {
//   width: 100%;
//   display: flex;
//   height:50px;
// }

// .table-scroll td,
// .table-scroll th {
//   flex-basis: 100%;
//   flex-grow: 2;
//   display: block;
//   padding: 1rem;
//   text-align: start;
// }


.small-col {
  flex-basis: 10%;
}

.comm-user-row:hover {
  color: $active-blue;
  background: $bg-color-on-hover;
  td:first-child {
    text-decoration: underline;
  }
}

.height-set-for-component {
  height: calc(100% - 112px);
}

table .more-actions-btn {
  visibility: hidden;
}
table tr:hover .more-actions-btn {
  visibility: visible;
}


.more-actions-div {
  position: absolute;
  height: 30px;
  width: 100px;
  padding: 6px;
  z-index: 99;
  border: $border-color;
  background: $primary-background;
  bottom: 0px;
  inset-inline-start:15%;
  ul {
    list-style-type: none;
    li {
      color: $text-color !important;
    }
    li:hover {
      color: $active-blue !important;
    }
  }
}

.border{
  border:$border-color !important;
}

.show-delete-icon:hover{
    position: relative;
    .parent-row-delete,  .parent-row-edit{
        visibility: visible;
    }
}

.parent-row-delete, .parent-row-edit{
    margin-inline-start: 3px;
    // position: absolute;
    // inset-inline-end :0px;
    z-index: 1;
    background: #525252;
    border: 1px solid #262626;
    width: 55px;
    height: 44px;
    padding: 12px;
    top: 0px;
    border-radius: 4px;
    visibility: hidden;
    color: #fff;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.activestatus {
  color: $active-green-color !important;
}

// //pagination
::v-deep {
        .page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
            color: $secondary-text-color !important;
            margin-bottom: 0px !important;
            font-size: 12px;
            margin-inline-end: 7px;
            margin-top: 1px;
            float:inline-start;
            display:none;
            margin-inline-start:5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display:none;
        }
        .VuePagination__pagination-item-next-chunk{
            display:none;
        }

        .VuePagination__pagination-item-prev-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page a:before{
            width:50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after{
            width:50px;
            content: " prev";
        }
        .v-list{
            padding:0px !important;
        }
        .v-list-item{
            text-align: start;
            border: $border-color !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title{
                    font-size: 14px !important;
                    color:$text-color !important;
            }
            }
        .v-menu__content{
            width:150px !important;
        }

  .multiselect__content-wrapper{
    display:none;
  }
  .multiselect__tag {
      background-color: $primary-background !important;
    }
    .multiselect__tags{
        background: $primary-background !important;
        border: $border-color !important;
    }
    .multiselect__option--highlight {
       background: $bg-color-on-hover !important;
    }
    .multiselect__content {
       background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__input:focus{
      box-shadow: none !important;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color:$text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$secondary-text-color  !important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: 12px !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect{
      color:$text-color !important;
      font-size: 12px !important;
      width:40%;
    }
    .multiselect__option--selected{
        background: $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid $bg-color-on-hover !important;
        position: absolute;
        display: block;
        background: $text-color;
        width: 100%;
        max-height: 240px;
        overflow: auto;
        border: $secondary-border-color;
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        z-index: 50;
        -webkit-overflow-scrolling: touch;
    }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color !important;
    }
    .multiselect__tags {
        background: $primary-background!important;
    }
}

.primary-btn-style{
    width: 100%;
    text-align: end;
    button{
      height: 35px;
      width: 70px;
      font-size:14px;
    }
    .text-light:hover{
      text-decoration: underline;
    }
}

.learn-about-text-styles{
  width: 200px !important;
  color:$learn-about-text-color;
  text-align: end;
  padding-inline-end: 17px;
  svg{
    margin-inline-end: 2px;
    margin-bottom: 3px;
  }
}

.learn-about-text-styles:hover{
  text-decoration: underline;
  color:$learn-about-text-color-hover;
}
</style>